module.exports = __webpack_public_path__ + "img/hi-bike_icon.38cc6ff8.png";